import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'
import { Icon } from '@wartek-id/icon-v2'

import type { TAssessmentStatus } from 'types/competency-profile'
import type { FC, HTMLProps, ReactElement } from 'react'

interface CompetencyCardProps extends HTMLProps<HTMLButtonElement> {
  name: string
  status: TAssessmentStatus
  icon: ReactElement
  notes: string
}

type TAssessmentStatusLabel = {
  [key in TAssessmentStatus]: string
}

export const CompetencyStatus: TAssessmentStatusLabel = {
  COMPLETED: 'Selesai.',
  RETAKE: 'Mohon ulangi refleksi.',
  DRAFTED: 'Lanjutkan refleksi ',
  NOT_CREATED: '',
}

const CompetencyCard: FC<CompetencyCardProps> = ({
  name,
  className,
  status,
  icon,
  notes,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={status == 'COMPLETED'}
      className={clsx(
        'rounded-lg flex flex-col border-subdued border p-4 bg-white w-full',
        className
      )}
    >
      <div className="flex flex-row items-center justify-between w-full">
        <div className="flex flex-row items-center gap-3.5">
          {icon}
          <Text variant="heading-sm" className="lowercase capitalize-words">
            {name}
          </Text>
        </div>
        {status != 'COMPLETED' && <Icon>chevron_right</Icon>}
      </div>
      {!!CompetencyStatus[status] && (
        <div className="bg-gray-0 p-3 rounded-lg flex flex-col gap-4 mt-4 w-full">
          <div className="flex flex-row gap-2 items-center">
            <Text>
              {CompetencyStatus[status]}
              {status == 'DRAFTED' && notes}
            </Text>
          </div>
        </div>
      )}
    </button>
  )
}
export default CompetencyCard
